import styled from 'styled-components';

export const InputWrapper = styled.div`

  width: ${props => props.width || "auto"};
  display: flex;
  align-items: center;
  justify-content: center;

`;
